export default class ProductCategoryModel {
  CategoryId: number | null;
  CategoryName: string;
  Slug: string;
  ImageUrl: string;
  DisplayOrder: number;
  IsActive: boolean;

  constructor() {
    this.CategoryId = null;
    this.CategoryName = '';
    this.Slug = '';
    this.ImageUrl = '';
    this.DisplayOrder = 0;
    this.IsActive = true;
  }
}
